import { render } from "./error-modal.vue?vue&type=template&id=037ead25&ts=true"
import script from "./error-modal.component.ts?vue&type=script&lang=ts"
export * from "./error-modal.component.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__